import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/change-password')({
  beforeLoad: () => {
    throw redirect({
      to: '/n/settings/account-and-security/change-password',
      replace: true,
    });
  },
});
